import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDirection = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 11",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10162_68610)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M5.45455 1.0918L1.09091 5.45543L5.45455 9.81907",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1.09091 5.45508H22.9091",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_10162_68610",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 10.9091,
			fill: "white"
		})
	}) })]
});
export default SvgArrowDirection;
